module.exports = "/images/logo-new-dark-2.svg?830c5bcf576ea238da12a3e5c7d9625f";